export const DEFAULT_ACCOUNT_NUMBER = '10 2490 0005 0000 4600 1211 9814';

export function getTransferInstructions(order) {
    if (order.payment.payment_type === 'standard') {
        return {
            accountNumber: DEFAULT_ACCOUNT_NUMBER,
            title: `Zamówienie nr ${order.id}`,
        };
    }

    const account = order.service_data.transaction_account_number;
    const parts = typeof account === 'string'
        ? account.match(/[A-Z]{2}|(?:(?:\d{2}|\d{4})(?=(\d{4})*$))/g)
        : null;
    return {
        accountNumber: parts ? parts.join(' ') : DEFAULT_ACCOUNT_NUMBER,
        title: order.service_data.transaction_id || order.service_data.invoice_number,
    };
}
